import { Icon, Panel, theme } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router';
import { useHistory, useParams } from 'react-router-dom';
import { TemplateManagementRoute } from 'sections/design/template-management/routes';
import { CreateButtonContainer, CreateIconCircle, CreateLabel } from './styles';
import qs from 'qs';

interface IProps {
  channel: string;
  templateType: string;
}

export function CreateTemplatePanel({ channel, templateType }: IProps) {
  const { t } = useTranslation('designs');
  const { siteId } = useParams<{ siteId: string }>();
  const { push } = useHistory();

  const handleCreateClick = () => {
    if (channel === 'onsite') {
      let path = generatePath(TemplateManagementRoute.CREATE_ONSITE, { siteId });

      if (templateType) {
        const query = qs.stringify({ templateType });
        path += '?' + query;
      }

      push(path);
    } else {
      push(generatePath(TemplateManagementRoute.CREATE, { siteId, channel }));
    }
  };

  return (
    <Panel padding={0} variation="clean">
      <CreateButtonContainer
        className="templatecreation"
        aria-label={t('designs:designGallery.addNewTemplate')}
        onClick={handleCreateClick}
        data-testid="CreateTemplatePanel"
      >
        <CreateIconCircle>
          <Icon color={theme.vars.newColor.darkGS2} icon={'plus'} size="extra-large" />
        </CreateIconCircle>
      </CreateButtonContainer>
      <CreateLabel>{t('designs:designGallery.addNewTemplate')}</CreateLabel>
    </Panel>
  );
}

export default CreateTemplatePanel;
